import React, { useEffect, useState, useCallback } from 'react';
import { summaryApi } from '../../api';
import moment from 'moment';
import { toast } from 'react-toastify';
import {
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Td,
  Input,
  SimpleGrid,
  Button,
  Stat,
  StatLabel,
  StatNumber,
  Box,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

export default function ListPackage() {
  const navigate = useNavigate();
  const [start, setStart] = useState(moment().startOf('week').format('YYYY-MM-DD'));
  const [end, setEnd] = useState(moment().format('YYYY-MM-DD'));
  const [sells, setSells] = useState([]);

  const handleStart = (e) => {
    setStart(e.target.value);
  };

  const handleEnd = (e) => {
    setEnd(e.target.value);
  };

  const onSearch = useCallback(() => {
    summaryApi.listPackages(start, end).then((res) => {
      setSells(res.data.data);
    });

    toast.info('...Buscando', { theme: 'dark', autoClose: 1000 });
  }, [start, end]);

  useEffect(() => {
    onSearch();
  }, [onSearch]);

  const renderTable = () => {
    return Object.entries(sells.users || {}).map(([key, value]) => (
      <Tr key={`row-${key}`}>
        <Td>{value}</Td>
        <Td>
          <Button onClick={() => navigate(`/usuarios/${key}`)}
        style={{'backgroundColor':'#f7931a','color':'white'}}>Ver usuario</Button>
        </Td>
      </Tr>
    ));
  };

  return (
    <>
      {/* Inputs para seleccionar fechas */}
      <SimpleGrid columns={3} spacing={10}>
        <Input
          placeholder="Fecha de inicio"
          size="md"
          type="date"
          onChange={handleStart}
          value={start}
        />
        <Input
          placeholder="Fecha de fin"
          size="md"
          type="date"
          onChange={handleEnd}
          value={end}
        />
        <Button onClick={onSearch}>Buscar</Button>
      </SimpleGrid>

      {/* Estadísticas */}
      <SimpleGrid marginTop="16px" columns={4} spacing={10}>
        <Stat>
          <Box borderWidth="1px" padding="10px" borderRadius="8px">
            <StatLabel>Vendido</StatLabel>
            <StatNumber>USD ${parseFloat(sells.price || 0).toFixed(2)}</StatNumber>
          </Box>
        </Stat>

        <Stat>
          <Box borderWidth="1px" padding="10px" borderRadius="8px">
            <StatLabel>ROI Generado</StatLabel>
            <StatNumber>USD ${parseFloat(sells.profit || 0).toFixed(2)}</StatNumber>
          </Box>
        </Stat>

        <Stat>
          <Box borderWidth="1px" padding="10px" borderRadius="8px">
            <StatLabel>Disponible</StatLabel>
            <StatNumber>USD ${parseFloat(sells.balance || 0).toFixed(2)}</StatNumber>
          </Box>
        </Stat>

        <Stat>
          <Box borderWidth="1px" padding="10px" borderRadius="8px">
            <StatLabel>Retirado</StatLabel>
            <StatNumber>USD ${parseFloat(sells.withdrawn || 0).toFixed(2)}</StatNumber>
          </Box>
        </Stat>

        <Stat>
          <Box borderWidth="1px" padding="10px" borderRadius="8px">
            <StatLabel>ROI Estimado total (puede aumentar)</StatLabel>
            <StatNumber>USD ${parseFloat(sells.automatically_ends || 0).toFixed(2)}</StatNumber>
          </Box>
        </Stat>

        <Stat>
          <Box borderWidth="1px" padding="10px" borderRadius="8px">
            <StatLabel>ROI Por generar (puede aumentar)</StatLabel>
            <StatNumber>USD ${parseFloat(sells.expected || 0).toFixed(2)}</StatNumber>
          </Box>
        </Stat>

        <Stat>
          <Box borderWidth="1px" padding="10px" borderRadius="8px">
            <StatLabel>Usuarios</StatLabel>
            <StatNumber>{Object.keys(sells.users || {}).length}</StatNumber>
          </Box>
        </Stat>
      </SimpleGrid>

      {/* Tabla de usuarios */}
      <Table variant="simple">
        <TableCaption fontSize={12} fontWeight="500">
          Usuarios a terminar
        </TableCaption>
        <Thead>
          <Tr>
            <Th>Usuario</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <tbody>{sells && renderTable()}</tbody>
      </Table>
    </>
  );
}
